import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'QrScannerInput',
  emits: ['detect', 'input'],
  setup(__props, { emit }) {



// const value = useVModel(props, 'value', emit)
// const value = computed({
//   set(v) {
//     emit('input', v)
//   },
//   get() {
//     return props.value
//   }
// })
const value = ref('')

// const textareaUrl = ref<HTMLTextAreaElement | null>(null)
const refs = getCurrentInstance()?.proxy.$refs
const nextTick = getCurrentInstance()?.proxy.$nextTick

const setFocus = () => {
  if (refs.textareaUrl) {
    nextTick(() => {
      refs.textareaUrl.focus()
    })
  }
}

onMounted(() => {
  setTimeout(() => {
    setFocus();
  }, 1)
})

const toQrResult = (url: string) => {
  console.log(url);

  return [{ rawValue: url }]
}


return { __sfc: true,emit, value, refs, nextTick, setFocus, toQrResult }
}

})